// src/components/programs/Table/ProgramsTableColumns.jsx

const ProgramsTableColumns = [
    { id: "program_number", labelAr: "رقم البرنامج", labelEn: "Program #", sortable: true },
    { id: "customer_title", labelAr: "اسم العميل", labelEn: "Customer Name", sortable: false },
    { id: "title_ar", labelAr: "اسم البرنامج (عربي)", labelEn: "Program Name (Arabic)", sortable: true },
    { id: "title_en", labelAr: "اسم البرنامج (إنجليزي)", labelEn: "Program Name (English)", sortable: true },
    { id: "duration", labelAr: "المدة", labelEn: "Duration", sortable: false },
    { id: "price", labelAr: "السعر", labelEn: "Price", sortable: true },
    { id: "discount", labelAr: "الخصم", labelEn: "Discount", sortable: false },
    { id: "confirmed", labelAr: "مؤكد", labelEn: "Confirmed", sortable: true },
    { id: "confirm_number", labelAr: "رقم التأكيد", labelEn: "Confirm #", sortable: true },
    { id: "closed", labelAr: "مغلق", labelEn: "Closed", sortable: true },
    { id: "close_number", labelAr: "رقم الإغلاق", labelEn: "Close #", sortable: true },
    { id: "updated_at", labelAr: "تاريخ التحديث", labelEn: "Updated At", sortable: true },
];

export default ProgramsTableColumns;
